import styled from 'styled-components';

const Container = styled.div`
	width: calc(80vw - 80px);
	height: 80vh;
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	justify-content: space-between;
`;

const Wrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: calc((80vw / 5) - 50px);
	margin: 0 0 60px 0;

  @media (max-width: 1400px) {
    width: calc(20vw - 50px);
	}

  @media (max-width: 1100px) {
    width: calc(25vw - 40px)
	}

	@media (max-width: 800px) {
    width: calc(40vw - 60px);
	}
`;

const Image = styled.div`
	position: relative;
	transform: translate(0px, 0px) scale(1);
	transition: all 0.2s ease-out;
	display: block;

	width: 100%;
	height: 0%;
	margin: 0;
	z-index: 1;

  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: cover;
	background-color: white;
	box-shadow: 0px 4px 16px -8px rgba(0,0,0,0.5);

	cursor: pointer;

	&:hover {
		transform: translate(0px, -8px) scale(1.05);
		box-shadow: 0px 8px 24px -8px rgba(0,0,0,0.4);
	}
}
`;

const ImageDescription = styled.p`
	position: absolute;
	top: calc(100% + 8px);
	left: 0px;
	font-size: 12px;
	width: 100%;
	text-align: center;
`;

const InputContainer = styled.div`
	padding: 0 0 2rem;
`;

export {
	Container,
	Wrapper,
	Image,
	ImageDescription,
	InputContainer,
}
